const IconDownload = ({ className }) => {
    return (
        <svg viewBox='0 0 33 34' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <rect y='0.866669' width='33' height='33' rx='16.5' />
            <path
                d='M8.88477 19.9051V22.4436C8.88477 23.8455 10.0213 24.9821 11.4232 24.9821H21.5771C22.979 24.9821 24.1155 23.8455 24.1155 22.4436V19.9051M16.5001 9.75128V19.059M13.1155 16.5205L16.5001 19.6634L19.7661 16.5205'
                stroke='white'
                strokeWidth='1.90385'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconDownload;
